export enum AIChatEnum {
    Question = 0,
    Response = 1,
    Error = 2,
  }